import { ReactNode } from "react";

import styles from "./Checkbox.module.scss";

interface Props {
  children?: ReactNode;
  checked: boolean,
  disabled?: boolean;
  onClick?: () => void;
  highlightRed?: boolean;
}

export function Checkbox({
  children,
  checked,
  disabled,
  onClick,
  highlightRed,
}: Props) {
  return <div
    className={styles.container}
    data-disabled={disabled}
    onClick={() => {
      if (disabled) return
      onClick && onClick()
    }}
  >
    <div
      tabIndex={0}
      className={styles.checkbox}
      // data props used for conditional styling
      data-checked={checked}
      data-highlightRed={highlightRed}
      data-disabled={disabled}
      onKeyDown={e => {
        if (disabled) return
        if (e.key === " ") {
          e.preventDefault()
          onClick && onClick()
        }
      }}
    >
    { checked &&
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7 9L4 6L2 8L7 13L15 5L13 3L7 9Z" fill="white"/>
      </svg>
    }
    </div>
    { children }
  </div>
}